import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-general-faq',
  imports: [RouterModule],
  templateUrl: './general-faq.component.html',
  styleUrl: './general-faq.component.css',
})
export class GeneralFaqComponent {

  constructor() {}
 
  ngOnInit() {}

}
